import { createAction, props } from '@ngrx/store';
import { GeneralError } from 'vidis-common';
import { MedicationScheme } from 'vidis-common/medication';

export const fetchMedicationScheme = createAction('[Medication] fetch medication');
export const setMedicationAction = createAction('[MEDICATION] set medications', props<{ medicationSchemes: MedicationScheme[] }>());
export const setMedicationErrorAction = createAction('[MEDICATION] set medication errors', props<{ medicationErrors: GeneralError[] }>());
export const clearMedicationErrorAction = createAction('[MEDICATION] clear Medication errors');
export const clearMedicationAction = createAction('[MEDICATION] clear Medication');
